const Download = () => import('@/pages/ProjectManagement/Download.vue');

export default [
    {
        path: '/project-management/file/:type/:id/download',
        name: 'projectManagement.file.download',
        component: Download,
        props: true,
        meta: {},
    },
];
